import { toLocaleDateString } from "utils/to-locale-date-string";

export default function(date) {
  return toLocaleDateString(date);
}
